import { mergeAttributes, Node } from '@tiptap/core';

export const Figcaption = Node.create({
  name: 'figcaption',
  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },
  content: '(bulletList|orderedList|paragraph)+',
  selectable: false,
  parseHTML() {
    return [
      {
        tag: 'figcaption',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['figcaption', mergeAttributes(HTMLAttributes), 0];
  },
});
